import React, { useState } from 'react';
import ScamPopup from './ScamPopup';
import SinglesPopup from './SinglesPopup';

/**
 * Development component to display both popups simultaneously
 * with controls for toggling them on/off
 */
const PopupDev: React.FC = () => {
  const [showScam, setShowScam] = useState(true);
  const [showSingles, setShowSingles] = useState(true);

  return (
    <div className="fixed inset-0 z-50 pointer-events-none">
      {/* Control panel with buttons - this should be clickable */}
      <div className="absolute top-4 right-4 bg-black bg-opacity-80 p-4 rounded-lg shadow-lg pointer-events-auto">
        <h1 className="text-xl font-bold mb-4 text-white">Popup-kontroller</h1>
        
        <div className="flex space-x-4 mb-4">
          <button 
            onClick={() => setShowScam(!showScam)}
            className={`px-4 py-2 rounded font-semibold ${
              showScam ? 'bg-red-600 text-white' : 'bg-gray-200 text-gray-800'
            }`}
          >
            {showScam ? 'Skjul svindel-popup' : 'Vis svindel-popup'}
          </button>
          
          <button 
            onClick={() => setShowSingles(!showSingles)}
            className={`px-4 py-2 rounded font-semibold ${
              showSingles ? 'bg-pink-600 text-white' : 'bg-gray-200 text-gray-800'
            }`}
          >
            {showSingles ? 'Skjul singles-popup' : 'Vis singles-popup'}
          </button>
        </div>
      </div>
      
      {/* Render popups */}
      {showScam && (
        <div className="pointer-events-auto">
          <ScamPopup onClose={() => setShowScam(false)} />
        </div>
      )}
      
      {showSingles && (
        <div className="pointer-events-auto">
          <SinglesPopup onClose={() => setShowSingles(false)} />
        </div>
      )}
    </div>
  );
};

export default PopupDev; 